import { faBox, faBoxOpen, faDollyBox, faTruck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './styles.css'
import moment from 'moment'
import 'moment/locale/es';
moment.locale('es');

export const Timeline = ({ data }) => {
    return (
        <div className="timeline-centered">
            {data.length > 0 ? <> {data.map(pedido => {

                const dia = moment(pedido.fecha).format("dddd")
                const fechaActual = moment(pedido.fecha).format("DD MMMM YYYY, hh:mm:ss a")
                return (<article className="timeline-card left-aligned" key={pedido.id}>
                    <div className="timeline-body">
                        <time className="time text-capitalize">
                            <span>{dia}</span>
                            <span>{fechaActual}</span>
                        </time>
                        <div className="timeline-icon bg-purple">
                            {pedido.nombre === "Pedido generado exitosamente" ?
                                <FontAwesomeIcon icon={faBox} className="icon" />
                                :
                                pedido.nombre === "En alistamiento" ?
                                    <FontAwesomeIcon icon={faDollyBox} className="icon" />
                                    :
                                    pedido.nombre === "Enviado" ?
                                        <FontAwesomeIcon icon={faTruck} className="icon" />
                                        : pedido.nombre === "Entregado" ?
                                            <FontAwesomeIcon icon={faBoxOpen} className="icon" />
                                            : null
                            }
                        </div>
                        <div className="timeline-label">
                            <p className='m-0'>{pedido.nombre}</p>
                            {pedido.numeroGuia ? <p className='m-0 mt-2'><small>Guia: {pedido.numeroGuia}</small></p> : null}
                            {pedido.mensaje ? <p className='m-0 mt-1'><small>{pedido.mensaje}</small></p> : null}
                        </div>
                    </div>
                </article>
                )
            })}
                <article className="timeline-card begin">
                    <div className="timeline-body">
                        <div className="timeline-icon">
                            <i className="entypo-flight"></i>
                        </div>
                    </div>
                </article>
            </>
                :
                <p>No existe seguimiento de pedido</p>
            }

        </div>
    )
}
